import React from 'react';
import styles from '../../../styles/portfolio/note.scss';


export const Note = props => {
    return (
        <div className={getContainerStyle()}>
            <div className={getHeaderStyle()}>
                {props.header}
            </div>
            <div className={getBodyStyle()}>
                {props.message}
            </div>
        </div>
    )

    function getHeaderStyle() {
        switch (props.type) {
            case 'warn':
                return styles.warnHeader;
            default:
                return styles.noteHeader;
        }
    }

    function getBodyStyle() {
        switch (props.type) {
            case 'warn':
                return styles.warnBody;
            default:
                return styles.noteBody;
        }
    }

    function getContainerStyle() {
        switch (props.type) {
            case 'warn':
                return styles.warnContainer;
            default:
                return styles.noteContainer;
        }
    }
};
